import React, { Component } from 'react'
import IconSVG from 'svg-inline-react'
import { Link } from 'react-router'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import ACCESS from 'utils/Access'

import { makeHasGate } from 'app/modules/gates/selectors'
import * as EndUserSelectors from 'app/modules/endUser/selectors'
import * as EndUserActions from 'app/modules/endUser/actions'
import * as PlaybookSelectors from 'app/modules/playbook/selectors'
import * as PlaybookActions from 'app/modules/playbook/actions'
import SendMessageButton from 'components/shared/SendMessageButton'
import PresenceIndicator from 'components/shared/PresenceIndicator'
import EnrollButton from 'components/customer/EnrollButton'
import DriftModal from 'components/shared/DriftModal'

import FOLLOWING_ICON_SRC from '!svg-inline?removeTags=true!images/svg/enduser-following.svg'
import FOLLOW_ICON_SRC from '!svg-inline?removeTags=true!images/svg/enduser-follow.svg'
import PROFILE_ICON_SRC from '!svg-inline?removeTags=true!images/svg/profile.svg'

class Information extends Component {
  static defaultProps = {
    showProfileLink: false,
    showTooltip: false
  }

  state = {
    unsubscribeModalVisible: false
  }

  componentWillMount() {
    if (this.props.endUser.email) {
      this.props.actions.checkUnsubscribed({ email: this.props.endUser.email })
      this.props.actions.fetchEnrolledPlaybookId({ email: this.props.endUser.email })
    }
    this.props.actions.fetchFollowing({ id: this.props.endUser.id })
  }

  handleFollowClick = () => {
    const { endUser, actions, following } = this.props
    actions.updateFollowing({ id: endUser.id, following: !following })
  }

  isLoading() {
    return typeof this.props.following === 'undefined'
  }

  getFollowButtonText() {
    const { following } = this.props
    if (this.isLoading()) return '...'
    if (following) return 'Following'
    return 'Follow'
  }

  renderFollowButton() {
    if (!ACCESS.hasGates('has_following')) return

    const { isPremiumTeam, showTooltip, showProfileLink, following } = this.props
    const loading = this.isLoading()

    const sharedProps = {
      style: showProfileLink
        ? { width: '48%', position: 'relative' }
        : { marginTop: 10, width: '100%', position: 'relative' },
      tooltip: showTooltip ? 'Follow users to be notified when they’re live on your site.' : undefined,
      flow: 'down',
      class: 'drift-button'
    }

    const children = [
      !loading && <IconSVG key="follow-icon" src={following ? FOLLOWING_ICON_SRC : FOLLOW_ICON_SRC} />,
      <span key="follow-text">{this.getFollowButtonText()}</span>
    ]

    if (isPremiumTeam) {
      return (
        <button is {...sharedProps} onClick={!loading && this.handleFollowClick}>
          {children}
        </button>
      )
    } else {
      return (
        <Link is {...sharedProps} to="/live">
          {children}
        </Link>
      )
    }
  }

  handleUnenrollClick = () => {
    this.props.actions.unenroll({ endUserId: this.props.endUser.id })
  }

  toggleUnsubscribeModal = () => {
    this.setState({ unsubscribeModalVisible: !this.state.unsubscribeModalVisible })
  }

  handleUnsubscribeClick = () => {
    this.props.actions.unsubscribe({ email: this.props.endUser.email })
    this.toggleUnsubscribeModal()
  }

  renderButtons() {
    const { inboxId, showProfileLink, endUser, enrolledPlaybookId, playbookList, unsubscribed } = this.props
    const enrolledPlaybook = playbookList.find(({ id }) => id === enrolledPlaybookId)
    return (
      <div style={{ padding: '20px 0px 5px' }}>
        <SendMessageButton endUserId={endUser.id} inboxId={inboxId} disabled={!inboxId} />
        {!showProfileLink && !!endUser.email && (
          <EnrollButton
            emails={[endUser.email]}
            style={{
              marginTop: 10,
              width: '100%'
            }}
          />
        )}
        {!!endUser.email && !showProfileLink && enrolledPlaybookId && (
          <button
            onClick={this.handleUnenrollClick}
            className="drift-button"
            style={{
              marginTop: 10,
              width: '100%'
            }}
          >
            Unenroll from {enrolledPlaybook && enrolledPlaybook.name}
          </button>
        )}
        {!!endUser.email && !showProfileLink && (
          <button
            onClick={this.toggleUnsubscribeModal}
            className="drift-button"
            style={{
              marginTop: 10,
              width: '100%'
            }}
            disabled={unsubscribed}
          >
            {unsubscribed ? 'Unsubscribed' : 'Unsubscribe'}
          </button>
        )}
        {showProfileLink ? (
          <div className="flex-space-between" style={{ marginTop: 10 }}>
            {this.renderFollowButton()}
            <Link
              to={`/contacts/details/${endUser.id}`}
              className="drift-button"
              style={{ width: '48%' }}
              target="_self"
            >
              <IconSVG src={PROFILE_ICON_SRC} />
              Profile
            </Link>
          </div>
        ) : (
          this.renderFollowButton()
        )}
        <DriftModal
          isOpen={this.state.unsubscribeModalVisible}
          onRequestClose={this.toggleUnsubscribeModal}
          primaryCTA="Unsubscribe"
          secondaryCTA="Cancel"
          onPrimaryClick={this.handleUnsubscribeClick}
          isDanger
          onSecondaryClick={this.toggleUnsubscribeModal}
          title="Unsubscribing a contact is permanent"
        >
          Are you sure you want to unsubscribe?
        </DriftModal>
      </div>
    )
  }

  render() {
    const { name, endUser, employmentTitle, editable, handleEdit } = this.props
    return (
      <div>
        <div style={{ padding: '5px 0px 0 100px', height: '50px' }}>
          <div
            className={`dsg-h3 ${name ? 'color-black' : 'color-navy'} truncate`}
            onClick={!name && editable && handleEdit}
          >
            {name || (editable ? 'Add Name' : 'Site Visitor')}
          </div>
          <div
            className={`flex dsg-Regular ${employmentTitle ? 'color-navy-dark' : 'color-navy'} truncate`}
            onClick={editable && !employmentTitle && handleEdit}
          >
            <PresenceIndicator endUser={endUser} />
          </div>
        </div>
        {this.renderButtons()}
      </div>
    )
  }
}

const makeMapStateToProps = () => {
  return (state, props) => {
    return {
      hasPresence: makeHasGate('has_presence')(state),
      isPremiumTeam: makeHasGate('premium_team')(state),
      enrolledPlaybookId: PlaybookSelectors.getEnrolledPlaybookId(state),
      playbookList: PlaybookSelectors.playbookList(state),
      following: EndUserSelectors.followingId(props.endUser.id)(state),
      unsubscribed: EndUserSelectors.unsubscribed(state)
    }
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchFollowing: EndUserActions.fetchFollowing,
      updateFollowing: EndUserActions.updateFollowing,
      fetchEnrolledPlaybookId: PlaybookActions.fetchEnrolledPlaybookId,
      unenroll: PlaybookActions.unenroll,
      checkUnsubscribed: EndUserActions.checkUnsubscribed,
      unsubscribe: EndUserActions.unsubscribe
    },
    dispatch
  )
})

export default connect(makeMapStateToProps, mapDispatchToProps)(Information)



// WEBPACK FOOTER //
// ./src/scripts/components/customer/TitleCard/Information.js